import { systemApi } from '../../../redux/api/SystemApi';
import { ContactList, ContactSearch } from '../types';

export const eventApi = systemApi.injectEndpoints({
    endpoints: (builder) => ({
        getContact: builder.query<ContactList, ContactSearch>({
            query: (body) => {
                return ({
                    url: `manager-contact/search?page=0&size=1000`,
                    method: 'POST',
                    body
                })
            },
            transformResponse: (response: { body: ContactList }, meta, arg) => {
                return response.body;
            }
        })
    })
})

export const { useLazyGetContactQuery } = eventApi;
